/* eslint-disable @typescript-eslint/unbound-method */
import { createContext, useContext } from "react";
import { LocalizerService } from "../../../utils/localizer";

export class LocalizerServiceContextType {
    constructor (public localizerService: LocalizerService) {}
}

export const LocalizerServiceContext = createContext<LocalizerServiceContextType | undefined>(undefined);
export const useLocalizerServiceContext = (): LocalizerServiceContextType => {
    const context = useContext(LocalizerServiceContext);
    if (!context) {
        throw new Error("useContext returned an undefined context for the LocalizerServiceContext");
    }
    return context;
};